<template>
  <div class="bg-base-0 p-4 sticky top-0">
    <div v-if="isLoading">
      <aha-skeleton-loader
        width="100%"
        height="20px"
        class="mb-2"
      />
      <div class="flex gap-2">
        <aha-skeleton-loader
          width="100%"
          height="20px"
        />
        <aha-skeleton-loader
          width="100%"
          height="20px"
        />
        <aha-skeleton-loader
          width="100%"
          height="20px"
        />
      </div>
    </div>
    <div v-else class="flex flex-col gap-3">
      <div class="title-name flex justify-between">
        <span v-if="participant?.name">{{ participant?.name }}</span>
        <span v-else>({{ $i18nPresenter.t('Anonymous') }})</span>
      </div>
      <div
        v-if="canUseDataMartIndividualReport || canUseDataMartIndividualReportV2 || canUseDataMartIndividualReportV5"
        class="mb-3 text-xs text-base-80"
      >
        <template v-if="canUseDataMartIndividualReportV5">
          {{ $i18nPresenter.t('Data may take up to {minutes} minutes to arrive', { minutes: 5 }) }}
        </template>
        <template v-else>
          {{ reportCronMessage }}
        </template>
      </div>
      <section class="info-section" v-if="hasInfo">
        <ul class="flex flex-col gap-2">
          <li v-if="participant?.email" class="flex gap-4">
            <b class="min-w-28">{{ $i18nPresenter.t('Email') }}</b>
            <span>{{ participant?.email }}</span>
          </li>
          <li v-if="participant?.organisation" class="flex gap-4">
            <b class="min-w-28">{{ $i18nPresenter.t('Company') }}</b>
            <span>{{ participant?.organisation }}</span>
          </li>
          <li v-if="participant?.team" class="flex gap-4">
            <b class="min-w-28">{{ $i18nPresenter.t('Team') }}</b>
            <span>{{ participant?.team }}</span>
          </li>
          <template v-if="canUseCollectParticipantInfo">
            <li v-for="info in participantInfo" :key="info?.name" class="flex gap-4">
              <b class="min-w-28 capitalize">{{ info?.name }}</b>
              <span>{{ info?.value }}</span>
            </li>
          </template>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { trim } from 'lodash'
import MessageMixin from '@/mixins/MessageMixin'

export default {
  mixins: [MessageMixin],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    participant: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('presentationSetting', ['canUseCollectParticipantInfo']),
    ...mapGetters('presentationReport', [
      'canUseDataMartIndividualReport',
      'canUseDataMartIndividualReportV2',
      'canUseDataMartIndividualReportV5',
    ]),
    legacyFields() {
      return ['email', 'organisation', 'team']
    },
    participantInfo() {
      // and value is not empty
      return this.participant?.participantInfo?.filter(
        (info) => !this.legacyFields.includes(info?.name) && !!trim(info?.value),
      )
    },
    hasInfo() {
      return this.participant?.email || this.organisation?.organisation || this.participant?.team ||
        this.participantInfo?.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.title-name {
  color:#282E3E;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.5;
  background: white;

}

.info-section {
  background: #F0F4FA;
  border-radius: 0.5rem;
  padding: 0.75rem;
}

</style>
